import { create } from 'zustand';

type StakeAdjustmentState = {
  stakeAdjusted: Record<string, boolean>;
  setStakeAdjusted: (id: string, value: boolean) => void;
  cloneStakeAdjusted: (fromId: string, toId: string) => void;
  deleteStakeAdjusted: (id: string) => void;
};

export const useStakeAdjustmentStore = create<StakeAdjustmentState>((set) => ({
  stakeAdjusted: {},
  setStakeAdjusted: (id, value) =>
    set((state) => ({
      stakeAdjusted: { ...state.stakeAdjusted, [id]: value },
    })),
  cloneStakeAdjusted: (fromId, toId) =>
    set((state) => ({
      stakeAdjusted: {
        ...state.stakeAdjusted,
        [toId]: state.stakeAdjusted[fromId],
      },
    })),
  deleteStakeAdjusted: (id) =>
    set((state) => {
      const { [id]: _, ...rest } = state.stakeAdjusted;
      return { stakeAdjusted: rest };
    }),
}));
